import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { TokenService } from './token.service';
import { ApiConstant } from '../../common/constant/api-constant';
import { HttpClient } from '@angular/common/http';
import { UserLogin } from '../../models/ViewModels/user-login';
import { Router } from '@angular/router';
import { ChangePassword, ResetPassword } from '../../models/ViewModels/password';

@Injectable({
  providedIn: 'root'
})

export class AuthService {

  constructor(
    private http: HttpClient,
    private tokenService: TokenService,
    private router: Router
  ) { }


  login(authData: UserLogin) {
    const body = {
      Username: authData.UserName,
      Password: authData.Password
    };

   return this.http.post(ApiConstant.AuthenticationApi.Login, body).pipe(map((res: any) => {
    const loginData = res;
    this.tokenService.SaveToken(loginData.Token);
   }));

  }

  // public CloseSession(sessionId: number): Observable<string> {
  //     return this.authHttp.post(ConstantAPI.AuthAPI.CloseSession, this.requestMessageService.GetRequestMessageWithOutObj(sessionId))
  //       .map(res => res.json());
  // }

  /* Method for logout and remove token
  * @Parameter No parameter
  * @Return Boolean
  */

  // logout() {
  //  return this.authHttp.post(ConstantAPI.AuthAPI.Logout, this.requestMessageService.GetRequestMessageWithOutObj("logout"))
  //     .map(res => res.json());
  // }

  public removeToken() {
    this.tokenService.RemoveToken();
    this.router.navigate(['login']);
  }

  // logoutFromAll() {
  //   this.authHttp.post(ConstantAPI.AuthAPI.LogoutAll, this.requestMessageService.GetRequestMessageWithOutObj("logout")).subscribe(res => {
  //     this.tokenService.RemoveToken();
  //     return true;
  //   }, error => {
  //     try {
  //       this.notification.error('Failed', error);
  //       return false;
  //     }catch(e) {
  //       return true;
  //     }
  //   })

  //   return true;
  // }

  /* Method for registration in the system
  * @Parameter No parameter
  * @Return Boolean
  */
  // registration(data: any) {
  //     return this.http.post(this.serverPath + '/api/account/registration', data);
  // }

  /* Method for change password
  * @Parameter newPassword, confirmPassword
  * @Return Response message from serve
  */
  changePassword(changePasswordData: ChangePassword) {
    return this.http.post(ApiConstant.AuthenticationApi.ChangePassword, changePasswordData);
  }

  /* Method for request reset password when forgot password
  * @Parameter user email
  * @Return Response string
  */
  // forgotPassword(data) {
  //   return this.http.post(this.serverPath + '', data).map(response => response.json());
  // }

  /* Method for Reset password
  * @Parameter email, new password, confirm password
  * @Return Response string
  */
  resetPassword(data: ResetPassword) {
    return this.http.post(ApiConstant.AuthenticationApi.ResetPassword, data);
  }

  /* Method for Checked that claimed user is authenticate or not ?
  * @Parameter No parameter
  * @Return Boolean
  */
  checkLogged() {
    if (this.tokenService.GetToken()) {
      return !this.tokenService.isTokenExpired();
    }else {
      return false;
    }
  }
  
  getLoggedUsername () {
    if (this.tokenService.GetToken()) {
      return this.tokenService.GetTokenValue('unique_name');
    }
    return '';
  }

  getLoggedUserType () : number {
    if (this.tokenService.GetToken()) {
      return  Number(this.tokenService.GetTokenValue('user_type'));  
    }
    return 0;
  }

  getLoggedEmail () {
    if (this.tokenService.GetToken()) {
      return this.tokenService.GetTokenValue('email');
    }
    return '';
  }
}
